import ObserveKeyboard from '@/directives/observe-keyboard';
import Focus from '@/directives/focus';

export default {
  ObserveKeyboard,
  Focus
};
